import { z } from 'zod';
import { contentStatusEnum, contentTypeEnum } from '../enums';
import { countryCodeSchema, isoDateTimeSchema, paginationQuerySchema, slugSchema, urlSchema } from './common';

// One content schema serving four types (docs/07). Download file fields are
// set server-side from the upload, never from the client payload.
export const createContentSchema = z.object({
  type: contentTypeEnum,
  title: z.string().trim().min(2).max(200),
  slug: slugSchema.optional(),
  excerpt: z.string().trim().max(300).nullable().optional(),
  body: z.string().max(100_000).nullable().optional(),
  heroImageUrl: urlSchema.nullable().optional(),
  videoUrl: urlSchema.nullable().optional(),
  tags: z.array(z.string().trim().min(1).max(40)).max(10).default([]),
  isFeatured: z.boolean().default(false),
  publishAt: isoDateTimeSchema.nullable().optional(),
  expireAt: isoDateTimeSchema.nullable().optional(),
  countryCodes: z.array(countryCodeSchema).optional(),
}).refine((c) => c.type !== 'video' || !!c.videoUrl, {
  message: 'video_requires_video_url',
  path: ['videoUrl'],
});
export type CreateContentPayload = z.infer<typeof createContentSchema>;

export const updateContentSchema = z.object({
  title: z.string().trim().min(2).max(200),
  slug: slugSchema,
  excerpt: z.string().trim().max(300).nullable(),
  body: z.string().max(100_000).nullable(),
  heroImageUrl: urlSchema.nullable(),
  videoUrl: urlSchema.nullable(),
  tags: z.array(z.string().trim().min(1).max(40)).max(10),
  isFeatured: z.boolean(),
  publishAt: isoDateTimeSchema.nullable(),
  expireAt: isoDateTimeSchema.nullable(),
  countryCodes: z.array(countryCodeSchema),
}).partial();
export type UpdateContentPayload = z.infer<typeof updateContentSchema>;

export const contentListQuerySchema = paginationQuerySchema.extend({
  type: contentTypeEnum.optional(),
  status: contentStatusEnum.optional(),
  search: z.string().trim().max(100).optional(),
  tag: z.string().trim().max(40).optional(),
});
export type ContentListQuery = z.infer<typeof contentListQuerySchema>;
